import { Container, Stack, Box, Typography, Checkbox, Alert, AlertTitle, TextField, Button, Radio } from "@mui/material";
import { ArrowBack, LockOutlined } from "@mui/icons-material";
import Page from "src/components/Page";
import UrbiaLoading from "src/components/UrbiaLoading";
import useCheckout from '../hooks/useCheckout'
import palette from "src/theme/palette";
import shadows from "src/theme/shadows";
import PaymentCard from "../components/PaymentCard"
import PaymentBoleto from "../components/PaymentBoleto"
import { maskCurrency } from "src/utils/formatNumber";

export default function Checkout() {
  const {
    isLoading,
    isLoadingButton,
    viabilityValue,
    conceptValue,
    totalValue,
    hasDirectorPlan,
    hasConcept,
    paymentMethod,
    paymentOptions,
    discount,
    cupom,
    errorCupom,
    cumpomMensagem,
    dwgValue,
    directorPlanValue,
    evuComplete,
    dwgStudy,
    isNewCalc,
    downloadStudy,
    downloadStudyValue,
    setHasConcept,
    setPaymentMethod,
    handlePayment,
    setCupom,
    aplicarCupom,
    setHasDirectorPlan,
    setEvuComplete,
    setDwgStudy,
    backToDashboard,
    handleServiceChange
  } = useCheckout();
  const hasNoNewCalcOptionSelected = !hasDirectorPlan && !evuComplete && !downloadStudy;
  const hasNoOldCalcOptionSelected = !hasDirectorPlan && !hasConcept && !dwgStudy && !evuComplete;

  return <Page title="Realizar Pagamento">
    {isLoading ?
      <UrbiaLoading />
      : <Container maxWidth='lg' sx={{ mt: 7 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography variant="h4">Realizar Pagamento</Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                gap: 0.5,
              }}>
              <LockOutlined color="disabled" />
              <Typography variant="body2" color="action.disabled">
                Compra Segura
              </Typography>
            </Box>
          </Box>
          <Box height={16} />
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Button startIcon={<ArrowBack />} size='medium' variant="text" onClick={backToDashboard} >
              Voltar para dashboard
            </Button>
            <Box >
              <Button variant='contained' onClick={() => { window.open('http://wa.me/+555195272351') }}>
                <Typography variant="subtitle2">
                  Suporte
                </Typography>
              </Button>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flex: 1 }}>
            <Box
              sx={{ borderBottom: 1, borderColor: 'divider', pb: 3 }}>
              {isNewCalc ?
                <>
                  {(hasDirectorPlan || hasNoNewCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoNewCalcOptionSelected && <Radio checked={hasDirectorPlan} onChange={() => handleServiceChange('directorPlan')} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Análise territorial:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(directorPlanValue)}</Typography>
                  </Box>}
                  {(evuComplete || hasNoNewCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoNewCalcOptionSelected && <Radio checked={evuComplete} onChange={() => handleServiceChange('completeEvu')} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>EVU Completo:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(viabilityValue)}</Typography>
                  </Box>}
                  {(evuComplete || hasNoNewCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} paddingLeft={4}>
                    {hasNoNewCalcOptionSelected && <Checkbox disabled={!evuComplete} checked={hasConcept} onChange={() => setHasConcept(!hasConcept)} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Concept:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(conceptValue)}</Typography>
                  </Box>}
                  {(evuComplete || hasNoNewCalcOptionSelected ) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} paddingLeft={4}>
                    {hasNoNewCalcOptionSelected && <Checkbox disabled={!evuComplete} checked={dwgStudy} onChange={() => setDwgStudy(!dwgStudy)} />}
                     <Typography variant="h6" sx={{ fontWeight: '500' }}>Anteprojeto:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(dwgValue)}</Typography>
                  </Box>}
                  {(downloadStudy || hasNoNewCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoNewCalcOptionSelected && <Radio checked={downloadStudy} onChange={() => handleServiceChange('downloadStudy')} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Download do (.dxf):</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(downloadStudyValue)}</Typography>
                  </Box>}
                </>
                :
                <>
                  {(evuComplete || hasNoOldCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoOldCalcOptionSelected && <Checkbox checked={evuComplete} onChange={() => setEvuComplete(!evuComplete)} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Estudo de viabilidade:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(viabilityValue)}</Typography>
                  </Box>}
                  {(dwgStudy || hasNoNewCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoOldCalcOptionSelected && <Checkbox checked={dwgStudy} onChange={() => setDwgStudy(!dwgStudy)} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Estudo em DWG:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(dwgValue)}</Typography>
                  </Box>}
                  {(hasConcept || hasNoOldCalcOptionSelected) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoOldCalcOptionSelected && <Checkbox checked={hasConcept} onChange={() => setHasConcept(!hasConcept)} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Concept:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(conceptValue)}</Typography>
                  </Box>}
                  {(hasDirectorPlan || hasNoOldCalcOptionSelected ) && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {hasNoOldCalcOptionSelected && <Checkbox checked={hasDirectorPlan} onChange={() => setHasDirectorPlan(!hasDirectorPlan)} />}
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>Análise do plano diretor:</Typography>
                    <Box ml={2} />
                    <Typography variant="h6" sx={{ fontWeight: '500' }}>{maskCurrency(directorPlanValue)}</Typography>
                  </Box>}
                </>
              }
              {discount &&
                <Box mt={2} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Alert severity="success">
                    <AlertTitle>Parabéns</AlertTitle>
                    Você ganhou {discount * 100}% de desconto no seu estudo, aproveite!
                  </Alert>
                </Box>
              }
              <Box mt={2} sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                <TextField
                  label="Cupom de desconto"
                  variant="outlined"
                  value={cupom}
                  onChange={e => setCupom(e.target.value)}
                  error={errorCupom}
                  helperText={cumpomMensagem}
                />
                <Button onClick={aplicarCupom}>Aplicar</Button>
              </Box>
              <Box mt={2} sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                <Typography variant="h5">Valor Total:</Typography>
                {discount ?
                  <>
                    <Typography variant="h5" color="grey.500" sx={{ fontWeight: '500' }}><s>{maskCurrency(totalValue)}</s></Typography>
                    <Typography variant="h5" sx={{ fontWeight: '500' }}>{maskCurrency((1 - discount) * totalValue)}</Typography>
                  </>
                  :
                  <Typography variant="h5" sx={{ fontWeight: '500' }}>{maskCurrency(totalValue)}</Typography>
                }
              </Box>
              <Box mt={3} />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* <Stack direction={"row"} spacing={2}>
                  {paymentOptions.map((option, index) =>
                    index !== 0 && <Box
                      p={2}
                      onClick={() => setPaymentMethod(index)}
                      sx={{
                        cursor: index === paymentMethod ? "inherit" : 'pointer',
                        backgroundColor: index === paymentMethod ? palette.light.primary.main : palette.light.common.white,
                        border: index === paymentMethod ? "2px solid " + palette.light.primary.main : "2px solid " + palette.light.grey[300],
                        borderRadius: '8px',
                        boxShadow: index === paymentMethod ? shadows.light[15] : 'inherit'
                      }}>
                      <Typography variant="h6" sx={{ color: index === paymentMethod ? palette.light.common.white : palette.light.grey[600] }}>{option}</Typography>
                    </Box>
                  )}
                </Stack> */}
                {paymentMethod === 0
                  ? <PaymentCard onSubmit={handlePayment} isLoadingButton={isLoadingButton} />
                  : <PaymentBoleto onSubmit={handlePayment} isLoadingButton={isLoadingButton} disabledButton={totalValue === 0} />}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    }
  </Page>
}
